import CoreClass from '../core/core-class';

export default function ( instance ) {
	return instance instanceof CoreClass;
}
